export const CONSTANTS = {
    "ENTRY_POINT_ADDRESS": "0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789",
    "KERNEL_FACTORY_ADDRESS": "0x7e3B523aDA6EC3fE6DC4e1c107Ed6DD641B6d4fc",
    "SALT": 0,
    "KERNEL_IMPLEMENTATION": "0x29C69905F09908C70da2D67a2B3d52B22E71F241",
    "ECDSA_VALIDATOR_ADDRESS": "0x93513fB6ea522d47ed8595f1B5037bd88578A914",
    "API_URL": "https://api.0xgasless.com",
    "SUPPORTED_TEST_CHAIN_IDS":  [ 5, 80001, 421613, 97],
    "SUPPORTED_MAIN_CHAIN_IDS":  [1, 137, 42161, 56, 250, 1284],
}